import { useCallback } from 'react';

export const useOpenChat = () => useCallback((event) => {
    event.preventDefault();

    if (!window.Communication) {
        return;
    }

    const api = window.Communication.API;
    const windowStatus = api?.chat.getWindowStatus();

    if (windowStatus?.activeScreen === 'CHAT_UI__ICON' || windowStatus?.hidden) {
        // #region @theme
        if (window?.Microsoft?.Omnichannel) {
            window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
        } else {
            api?.chat.maximize();
        }
        // #endregion
        api?.inbox.minimize();
        // @theme remived
    }
}, []);
